import { useMemo } from "react";
import { useIntl } from "umi";

export const useTipsContent = () => {
  const { formatMessage, locale } = useIntl();

  const tipsContentMap: { [key: string]: string; } = useMemo(()=>({
    '/benchmark/pcconsole/explore': formatMessage({ id: 'dbh_studio_report_bechmark_tips' }),
    '/benchmark/mobile/explore': formatMessage({ id: 'dbh_studio_report_bechmark_tips' }),
  }), [locale]);
  
  // 防止后续benchmark加了参数但是映射不到指标注释
  const getValueByKey = (key: string, dataMap:  { [key: string]: string; }): string | undefined => {
    // 获取键的前缀
    for (const prefix of Object.keys(dataMap)) {
      if (key?.startsWith(prefix)) {
        return dataMap?.[prefix];
      }
    }
    // 如果没有匹配的前缀，返回 ''
    return '';
  };

  return {tipsContentMap, getValueByKey};
};